import UserMultiple20 from '@carbon/icons-react/es/user--multiple/20';
import React, { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { PartnerCompany } from 'api/partner/types';
import { PageLoading } from 'components/atoms/loading';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { useAllCompanies } from 'queries/account';
import { useGetAllPartnerPermissions } from 'queries/partner';
import { TeamMembersList } from '../partner';

const Header = styled.span`
  align-items: center;
  display: flex;
  flex: 1;
`;

export const PartnerTeamMemberSettingsPage: FC = () => {
  const title = useTranslation('settings.team_members.title');
  const { isLoading: isPartnerPermissionsLoading } =
    useGetAllPartnerPermissions();
  const {
    user: {
      company: { companyId: currentUserCompanyId },
    },
  } = useUser();
  const { isLoading: isCompaniesLoading, data: companies } = useAllCompanies();
  const partner = useMemo(
    () =>
      (companies ?? []).find(
        ({ companyId }) => companyId === currentUserCompanyId,
      ),
    [companies, currentUserCompanyId],
  );

  return (
    <Page>
      <Helmet>{title}</Helmet>
      <Page.Header
        $white
        sticky
        title={
          <Header>
            <HeaderWithIconTitle icon={<UserMultiple20 />} title={title} />
          </Header>
        }
      />
      <Page.Content>
        {isPartnerPermissionsLoading ||
        isCompaniesLoading ||
        partner == null ? (
          <PageLoading />
        ) : (
          <TeamMembersList partner={partner as PartnerCompany} />
        )}
      </Page.Content>
    </Page>
  );
};
